import { z } from 'zod';
import { NODE_COLOR_OVERRIDES } from './node-system';
import { EdgeMetricsSchema } from '../metrics/contracts';

/**
 * SPEC-006 §5/§6 — canonical edge type/style contracts. Edge is a
 * declarative, directed relation between two nodes; it never executes
 * anything (§4). `data.metrics.conversion` (DF-103) is owned by SPEC-008.
 */
export const EDGE_TYPE_IDS = ['standard', 'conditional'] as const;
export type EdgeTypeId = (typeof EDGE_TYPE_IDS)[number];

export const EDGE_STYLES = ['solid', 'dashed'] as const;
export type EdgeStyle = (typeof EDGE_STYLES)[number];

/** Edge color override reuses the same controlled token set as nodes (EDGE-REQ-024). */
export const EDGE_COLOR_OVERRIDES = NODE_COLOR_OVERRIDES;
export type EdgeColorOverride = (typeof EDGE_COLOR_OVERRIDES)[number];

export const EDGE_LABEL_MAX_LENGTH = 80;

export const EdgeDataSchema = z
  .object({
    label: z.string().max(EDGE_LABEL_MAX_LENGTH).optional(),
    style: z.enum(EDGE_STYLES).default('solid'),
    animated: z.boolean().default(false),
    colorOverride: z.enum(EDGE_COLOR_OVERRIDES).optional(),
    /** SPEC-008 §17/AC-063 — absent on older graphs; normalizes to `{}`. */
    metrics: EdgeMetricsSchema,
  })
  .passthrough();

export type EdgeData = z.infer<typeof EdgeDataSchema>;

export function isKnownEdgeType(type: string): type is EdgeTypeId {
  return (EDGE_TYPE_IDS as readonly string[]).includes(type);
}
